import * as React from 'react';

type UseSelectIdsParams = {
  name?: string;
  hasValue: boolean;
  error?: string;
  hideErrorMessage?: boolean;
};

export function useSelectIds({
  name,
  hasValue,
  error,
  hideErrorMessage,
}: UseSelectIdsParams) {
  const reactId = React.useId().replace(/:/g, '');
  const baseId = name ? `dash-select-${name}` : `dash-select-${reactId}`;
  const triggerId = `${baseId}-trigger`;
  const labelId = `${baseId}-label`;
  const valueId = `${baseId}-value`;
  const helperTextId = `${baseId}-helper`;
  const errorId = `${baseId}-error`;
  const listboxId = `${baseId}-listbox`;
  const describedErrorId = error && !hideErrorMessage ? errorId : undefined;
  const describedBy =
    [!hasValue ? helperTextId : null, describedErrorId].filter(Boolean).join(' ') ||
    undefined;
  const getOptionId = React.useCallback(
    (index: number) => `${baseId}-option-${index}`,
    [baseId],
  );

  return {
    triggerId,
    labelId,
    valueId,
    helperTextId,
    errorId,
    describedErrorId,
    listboxId,
    describedBy,
    getOptionId,
  };
}
